import { Deserializable } from '../protocols/deserializable';
import { Selectable } from '../protocols/selectable';
import { UniquelyIdentifiable } from '../protocols/uniquely-identifiable';
import { RoleUser } from './role-user';
import { RolePermission } from './role-permission';

export class Role implements Deserializable, Selectable, UniquelyIdentifiable {
  public id!: number;
  public name!: string;
  public description!: string;
  public users?: RoleUser[];
  public permissions?: RolePermission[];

  // Not from API, but used to prevent duplicate roles being assigned to a user
  public isAssignedToUser = false;

  onDeserialize(): void {
    const Deserialize = window?.injector?.Deserialize;
    if (this.users) {
      this.users = Deserialize?.arrayOf(RoleUser, this.users);
    }

    if (this.permissions) {
      this.permissions = Deserialize?.arrayOf(RolePermission, this.permissions);
    }
  }

  getSelectionTitle(): string {
    return this.name;
  }

  getSelectionUniqueIdentifier(): any {
    return this.id;
  }

  getSelectionValue(): any {
    return this.id;
  }

  getSelectionIsDisabled(): boolean {
    return this.isAssignedToUser;
  }

  getUniqueIdentifier(): string {
    return `${this.id} +
    ${this.name} +
    ${this.description} +
    ${this.users} +
    ${this.permissions}`;
  }
}
